import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AvailabilityService } from 'src/app/services/availability.service';
import { BasketTotalsService } from 'src/app/services/basket-totals.service';
import { BasketService } from 'src/app/services/basket.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { ToolsService } from 'src/app/services/tools.service';
import { TrybeService } from 'src/app/services/trybe.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-room-select',
    templateUrl: './room-select.component.html',
    styleUrls: ['./room-select.component.css']
})
export class RoomSelectComponent implements OnInit {

    basket = undefined;
    basketMeta = undefined;
    showRateUpsellText = false;

    booking$ = this.store.select<any>('basketBooking');
    availabilitySearch$ = this.store.select<any>('availabilitySearch')
    infoPlan$ = this.store.select<any>('infoPlan')
    overlays$ = this.store.select<any>('overlays')

    ratePlans = [];
    addOns = [];
    guests = [];
    allowTriggerSpa = false;
    showPackageModel = false;
    trybeDate = '';
    userModal = false;
    message = '';

    processingBooking = false;

    addedFfSessions = false;
    showAdditionalNight = false;

    showGuestModal = false;
    bookingError = false;

    afternoon: any = {
        "choice_id": "67f8cd43786876f0a90eb31b",
        "option_id": "67f61e76fa750110d00213b3",
        "time": "2025-05-30T12:00:00+01:00",
        "duration": 540,
        "item_configuration": {
            "choice_id": "67f8cd43786876f0a90eb31b",
            "option_id": "67f61e76fa750110d00213b3",
            "time": "2025-05-30T12:00:00+01:00",
            "duration": 540,
            "option_ids": []
        },
        "basketItemId": "",
        "basket_id": null
    }
    morning: any = {
        "choice_id": "67f8cd43786876f0a90eb31b",
        "option_id": "67f61f71906c9758ba087162",
        "time": "2025-05-31T09:00:00+01:00",
        "duration": 180,
        "item_configuration": {
            "choice_id": "67f8cd43786876f0a90eb31b",
            "option_id": "67f61f71906c9758ba087162",
            "time": "2025-05-31T09:00:00+01:00",
            "duration": 180,
            "option_ids": []
        }, "basketItemId": "",
        "basket_id": null
    }

    trybeBasket = undefined;
    spaGuests = [];

    constructor(
        private store: Store,
        private router: Router,
        private availabilityService: AvailabilityService,
        private basketService: BasketService,
        private overlayService: OverlayService,
        private basketTotalsService: BasketTotalsService,
        private toolsService: ToolsService,
        private tryBeService: TrybeService,
    ) { }

    ngOnInit() {
        this.basketMeta = this.store.selectForLocal('basketMeta');

        this.basket = this.basketService.getBasket();
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');

        this.getPricing()

        // this.loadRates('BB')

        const totalGuests = +availabilitySearch.adults + +availabilitySearch.children;

        for (let g = 1; g <= totalGuests; g++) {
            const guest = {
                firstname: '',
                surname: '',
                telephone: '07469757202',
                email: '',
                add1: '1 Peacock Road',
                add2: 'Bromham',
                add3: '',
                town: 'Bedford',
                county: 'Bedfordshire',
                country: 'GB',
                postcode: 'MK43 8TG'
            }
            if (g === 1) {
                guest.firstname = this.basket.user.firstname;
                guest.surname = this.basket.user.surname;
                guest.telephone = this.basket.user.telephone;
                guest.email = this.basket.user.username;
            }
            this.guests.push(guest);
        }
    }


    getPricing() {
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');
        const basketBooking = this.store.selectForLocal('basketBooking');

        this.showRateUpsellText = false;

        this.availabilityService.loadAvailability(availabilitySearch).subscribe(data => {
            console.log(data);
            const booking = this.store.selectForLocal('basketBooking')


            const ratePlans = this.store.selectForLocal('ratePlans');
            console.log(ratePlans)
            if (ratePlans.length) {

                for (let i = 0; i < ratePlans.length; i++) {
                    if (ratePlans[i].additionalNights) {
                        this.showRateUpsellText = true;
                    }
                }

                if (basketBooking.planSelected) {
                    booking.planSelected = basketBooking.planSelected;
                    booking.roomPricing.roomCostForStay = basketBooking.planSelected.costOfStay;
                    // } else {
                    //     booking.planSelected = ratePlans[0];
                    //     booking.roomPricing.roomCostForStay = ratePlans[0].costOfStay;
                }
                console.log(booking)
            }
            this.ratePlans = ratePlans;
            this.store.set('basketBooking', booking)

        })

    }
    selectRatePlan(ratePlan) {
        const booking = this.store.selectForLocal('basketBooking')
        // this.planSelected = ratePlan;

        booking.planSelected = ratePlan;
        booking.roomPricing.roomCostForStay = ratePlan.costOfStay;
        console.log(booking)

        this.store.set('basketBooking', booking)


        if (ratePlan.ratePlanCode === 'BOP26') {
            const availabilitySearch = this.store.selectForLocal('availabilitySearch');

            const bstFix = new Date(availabilitySearch.checkIn);

            if (bstFix.getUTCHours() > 22) {
                bstFix.setTime(bstFix.getTime() + 6 * 60 * 60 * 1000);
                availabilitySearch.checkIn = new Date(bstFix);
            }


            this.trybeDate = availabilitySearch.checkIn.toISOString().slice(0, 10);
            console.log(availabilitySearch.checkIn, availabilitySearch.checkIn.toISOString().slice(0, 10))

            this.showPackageModel = true;

        }

    }

    loadRates(ratePlanCode) {
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');
        this.store.set('ratePlansUpsell', []);
        this.showRateUpsellText = false;

        this.availabilityService.loadRates('searchbar.component.ts').subscribe(data => {
            // this.ratePlans = data.ratePlans;
            for (let i = 0; i < data.ratePlans.length; i++) {
                if (data.ratePlans[i].additionalNights) {
                    this.showRateUpsellText = true;
                }
                if (ratePlanCode === data.ratePlans[i].ratePlanCode) {
                    const booking = this.store.selectForLocal('basketBooking');
                    booking.roomPricing.roomCostForStay = data.ratePlans[i].costOfStay;
                    booking.planSelected = data.ratePlans[i];
                    this.store.set('basketBooking', booking);
                    this.allowTriggerSpa = data.ratePlans[i].triggerSpa;
                }
            }
        })
    }

    loadUpsellRates() {
        this.availabilityService.loadUpsellRates('searchbar.component.ts').subscribe(data => {
        })
    }
    viewRate(ratePlan) {
        this.store.set('infoPlan', ratePlan)
        this.overlayService.open('ratePlanInfo')

    }
    triggerAdditionalNights() {
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');
        const booking = this.store.selectForLocal('basketBooking');
        console.log(availabilitySearch)
        console.log(booking);
        if (booking.planSelected.additionalNights && booking.planSelected.additionalNights.nextNight) {
            this.showAdditionalNight = true;
        } else {
            this.addToBasket(false);
        }

    }
    closeAdditionalNights(e) {
        console.log(e)
        this.showAdditionalNight = false;
        if (!e) {
            return false;
        }

        if (e.accepted) {
            console.log('ACCEPTED')
            this.store.set('availabilitySearch', e.av);


            const booking = this.store.selectForLocal('basketBooking');

            booking.roomPricing.roomCostForStay = e.rp.costOfStay;
            booking.planSelected = e.rp;
            booking.additionalNightsUpsell = true;

            this.store.set('booking', booking);

            if (e.ratePlanCode === 'BOP26') {
                // this.trybeDate = availabilitySearch.checkIn.toISOString().slice(0, 10);

                this.showPackageModel = true;

            }
            this.store.set('basketBooking', booking);
            console.log(this.store.selectForLocal('availabilitySearch'))
            console.log(this.store.selectForLocal('basketBooking'))
            console.log('END OF ACCEPTED')
        }
        this.addToBasket(false);
    }

    addToBasket(trybeBasket) {
        console.log(this.addOns);
        const booking = this.store.selectForLocal('basketBooking');
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');

        if (!booking.planSelected) {
            this.message = 'Plan must be selected';
            return;
        }

        availabilitySearch.addOns = this.addOns;
        console.log(availabilitySearch)

        booking.guests = this.guests;

        let basketToSaveToDB = this.basketService.addToBasket(availabilitySearch, booking, trybeBasket);
        console.log(basketToSaveToDB)


        let basket = this.store.selectForLocal('basket');

        const itemIdx = basket.items.length - 1;
        if (this.trybeBasket) {


            basket.items[itemIdx].spa.trybeBasket = this.trybeBasket;
            basket.items[itemIdx].checkoutTotals = this.basketTotalsService.calculateItemTotals(basket, basket.items[itemIdx], basket.user)
            basket = this.basketTotalsService.totalBasket(basket);

            this.basketService.saveBasket(basket);
            //     this.router.navigate(['/', 'checkout'])

            // } else {
            //     this.router.navigate(['/', 'checkout', 'addons', basket.items.length - 1])

        }
        this.processingBooking = false;




        this.basketService.saveBasketToDB(basketToSaveToDB).subscribe(data => {
            if (basket.items[itemIdx].room.hotelId === 'HOTEL001' || basket.items[itemIdx].room.hotelId === 'HOTEL002') {
                this.router.navigate(['/bookings/create/spa/', itemIdx])
            } else {
                if (basket.items[itemIdx].room.hotelId === 'HOTEL001' || basket.items[itemIdx].room.hotelId === 'HOTEL002' || basket.items[itemIdx].room.hotelId === 'HOTEL005') {
                    this.router.navigate(['/bookings/create/opentable'])
                } else {
                    this.router.navigate(['/bookings/create/payment'])

                }
            }
        })
    }

    killTryBe() {
        this.showPackageModel = false;
        const booking = this.store.selectForLocal('basketBooking');
        booking.planSelected = undefined;
        this.store.set('basketBooking', booking);
    }
    packageAdded(trybeBasket) {
        this.showPackageModel = false;
        console.log(trybeBasket)
        this.addToBasket(trybeBasket);
    }

    toggleUserModal() {
        if (!this.userModal) {
            this.userModal = true;
        } else {
            this.userModal = false;
        }
        console.log(this.userModal)
    }
    savedUser() {
        this.basket = this.basketService.getBasket()
        console.log(this.basket.user);
        this.userModal = false;

    }


    triggerGuests() {
        this.showGuestModal = true;
    }
    guestsAdded(e) {
        console.log(e);
        if (e.action) {
            this.spaGuests = e.guestsForOutput;
            this.triggerSpa();
        }
        this.showGuestModal = false;
    }

    async triggerSpa() {
        this.bookingError = false;
        this.processingBooking = true;

        try {
            console.log(`creating the basket`);
            const response = await this.tryBeService.basketCreate().toPromise();
            this.trybeBasket = response.data.data;
            console.log(`Created basketId ${this.trybeBasket.id}`);
            this.addedFfSessions = true;

            await this.addPackageItem();

        } catch (error) {
            console.error('Error in triggerSpa:', error);
            this.processingBooking = false;
            this.bookingError = true;
        }
    }


    async addPackageItem() {
        console.log(this.spaGuests)
        const availabilitySearch = this.store.selectForLocal('availabilitySearch');
        let dates = [];

        for (let d = 0; d <= +availabilitySearch.nights; d++) {
            const dDate = this.toolsService.mySQLDateFromEpochDay(+availabilitySearch.checkInDay + d)

            const date = new Date(this.toolsService.dateFromEpochDay(+availabilitySearch.checkInDay + d));
            const formattedDate = `${date.getDate().toString().padStart(2, '0')} ${(date.getMonth() + 1).toString().padStart(2, '0')} ${date.getFullYear()}`;
            dates.push(dDate);
        }

        try {

            const packageId = '67f8cccddffb14efdf055053';

            for (let d = 0; d < dates.length; d++) {

                for (let i = 0; i < this.spaGuests.length; i++) {

                    const response = await this.tryBeService
                        .basketAddPackageItem(packageId, this.trybeBasket.id, dates[d], this.spaGuests[i])
                        .toPromise();


                    this.trybeBasket = response.data.data;
                    this.spaGuests[i][0].id = this.trybeBasket.guests[i].id




                    let triggerAddToBasket = false;
                    if (i === this.spaGuests.length - 1 && d === dates.length - 1) {
                        triggerAddToBasket = true;
                    }

                    const morning = this.morning;
                    const afternoon = this.afternoon;
                    let todaysDate = dates[d]
                    todaysDate = new Date(todaysDate);

                    let morningTime = new Date(morning.time);
                    morningTime.setFullYear(todaysDate.getFullYear())
                    morningTime.setMonth(todaysDate.getMonth())
                    morningTime.setDate(todaysDate.getDate()).toString();
                    morning.time = this.toLocalISOString(morningTime)
                    morning.item_configuration.time = morning.time;

                    let afternoonTime = new Date(afternoon.time);
                    afternoonTime.setFullYear(todaysDate.getFullYear())
                    afternoonTime.setMonth(todaysDate.getMonth())
                    afternoonTime.setDate(todaysDate.getDate()).toString();
                    afternoon.time = this.toLocalISOString(afternoonTime)
                    afternoon.item_configuration.time = afternoon.time;
                    // afternoonTime = afternoonTime.setDate(todaysDate.getDate())

                    if (d < 1) {


                        await this.addPackageOption(afternoon, triggerAddToBasket, todaysDate);
                    }
                    if (d === (dates.length - 1)) {

                        await this.addPackageOption(morning, triggerAddToBasket, todaysDate);
                    }
                    if (d > 0 && d !== (dates.length - 1)) {


                        await this.addPackageOption(morning, triggerAddToBasket, todaysDate);
                        await this.addPackageOption(afternoon, triggerAddToBasket, todaysDate);
                    }

                }
            }
            // await this.addPackageOption(this.optionTwo, true);
        } catch (error) {
            this.processingBooking = false;
            console.error('Error in addPackageItem:', error);
            this.bookingError = true;
        }
    }


    async addPackageOption(option: any, triggerAddToBasket, date) {
        try {

            console.log(this.trybeBasket)
            const response = await this.tryBeService
                .basketAddSpaPackageItemOption(this.trybeBasket.id, this.trybeBasket.items[this.trybeBasket.items.length - 1].id, option, date)
                .toPromise();

            if (response.data.error) {
                console.error(response.data.error);
                this.processingBooking = false;
                this.bookingError = true;
            } else {
                this.trybeBasket = response.data.data;
                if (triggerAddToBasket) {
                    this.addToBasket(this.trybeBasket);
                }
            }
        } catch (error) {
            console.error('Error in addPackageOption:', error);
            this.processingBooking = false;
        }
    }


    toLocalISOString(date: Date): string {
        const pad = (n: number) => n.toString().padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are 0-based
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const offsetMinutes = date.getTimezoneOffset();
        const offsetSign = offsetMinutes > 0 ? '-' : '+';
        const absOffsetMinutes = Math.abs(offsetMinutes);
        const offsetHours = pad(Math.floor(absOffsetMinutes / 60));
        const offsetMins = pad(absOffsetMinutes % 60);

        const offset = `${offsetSign}${offsetHours}:${offsetMins}`;

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;
    }

}
